import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardGuard } from './dashboard.guard';
import { IndexComponent } from './pages/index/index.component';

const routes: Routes = [{ path: '', component: IndexComponent, canActivate: [DashboardGuard] }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule {}
